<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Список расписаний</div>
            <a class="title-block__btn btn-add btn-primary btn"
               :href="route_create_page">Добавить расписание</a>
        </div>
    </div>

    <div class="filter-table">
        <div class="filter-table__input-wrap search-control">
            <input type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
            <button class="search-control__input-btn reset-btn">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"
                        fill="currentColor" />
                </svg>
            </button>
        </div>
    </div>
    <table-element :actions="actions" :thead="thead" :tbody="tbody" @deleteItem="deleteWorktime"></table-element>
    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
<list-view></list-view>
</template>

<script>
import TableElement from "../../../elements/TableElement";
import PaginationElement from "../../../elements/PaginationElement";
import ChangePage from "../../../helpers/ChangePage";
import Worktime from "../../../models/Worktime";

export default {
    name: "WorktimeComponent",
    components: {
        TableElement,
        PaginationElement
    },
    props: {
        route_create_page: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_update: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            worktime: new Worktime({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),
            search: '',
            actions: [
                {
                    text: 'Удалить',
                    emit: 'deleteItem',
                    svg: `<a class="m-1" title="Удалить">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 3.41463H12C12 2.89714 11.7893 2.40084 11.4142 2.03491C11.0391 1.66899 10.5304 1.46341 10 1.46341C9.46957 1.46341 8.96086 1.66899 8.58579 2.03491C8.21071 2.40084 8 2.89714 8 3.41463ZM6.5 3.41463C6.5 2.96622 6.59053 2.52219 6.76642 2.10791C6.94231 1.69363 7.20012 1.3172 7.52513 1.00012C7.85013 0.683045 8.23597 0.431525 8.66061 0.259924C9.08525 0.0883221 9.54037 0 10 0C10.4596 0 10.9148 0.0883221 11.3394 0.259924C11.764 0.431525 12.1499 0.683045 12.4749 1.00012C12.7999 1.3172 13.0577 1.69363 13.2336 2.10791C13.4095 2.52219 13.5 2.96622 13.5 3.41463H19.25C19.4489 3.41463 19.6397 3.49172 19.7803 3.62895C19.921 3.76617 20 3.95228 20 4.14634C20 4.3404 19.921 4.52652 19.7803 4.66374C19.6397 4.80096 19.4489 4.87805 19.25 4.87805H17.93L16.76 16.6937C16.6702 17.599 16.238 18.4393 15.5477 19.0506C14.8573 19.6619 13.9583 20.0003 13.026 20H6.974C6.04186 20.0001 5.1431 19.6615 4.45295 19.0502C3.7628 18.439 3.33073 17.5988 3.241 16.6937L2.07 4.87805H0.75C0.551088 4.87805 0.360322 4.80096 0.21967 4.66374C0.0790175 4.52652 0 4.3404 0 4.14634C0 3.95228 0.0790175 3.76617 0.21967 3.62895C0.360322 3.49172 0.551088 3.41463 0.75 3.41463H6.5ZM8.5 8.04878C8.5 7.85472 8.42098 7.66861 8.28033 7.53139C8.13968 7.39416 7.94891 7.31707 7.75 7.31707C7.55109 7.31707 7.36032 7.39416 7.21967 7.53139C7.07902 7.66861 7 7.85472 7 8.04878V15.3659C7 15.5599 7.07902 15.746 7.21967 15.8833C7.36032 16.0205 7.55109 16.0976 7.75 16.0976C7.94891 16.0976 8.13968 16.0205 8.28033 15.8833C8.42098 15.746 8.5 15.5599 8.5 15.3659V8.04878ZM12.25 7.31707C12.4489 7.31707 12.6397 7.39416 12.7803 7.53139C12.921 7.66861 13 7.85472 13 8.04878V15.3659C13 15.5599 12.921 15.746 12.7803 15.8833C12.6397 16.0205 12.4489 16.0976 12.25 16.0976C12.0511 16.0976 11.8603 16.0205 11.7197 15.8833C11.579 15.746 11.5 15.5599 11.5 15.3659V8.04878C11.5 7.85472 11.579 7.66861 11.7197 7.53139C11.8603 7.39416 12.0511 7.31707 12.25 7.31707ZM4.734 16.5532C4.78794 17.0962 5.04724 17.6002 5.46137 17.9669C5.87549 18.3336 6.41475 18.5367 6.974 18.5366H13.026C13.5853 18.5367 14.1245 18.3336 14.5386 17.9669C14.9528 17.6002 15.2121 17.0962 15.266 16.5532L16.424 4.87805H3.576L4.734 16.5532Z" fill="#004FAB" fill-opacity="0.25"/>
                    </svg>
                </a>`
                }
            ],
            thead: [
                'Понедельник начало',
                'Понедельник конец',
                'Вторник начало',
                'Вторник конец',
                'Среда начало',
                'Среда конец',
            ],
            tbody: [],
            count: 1,
            limit: 10,
            page: 1,
        }
    },
    methods: {
        deleteWorktime: function (params) {
            if(params.hasOwnProperty('id'))
            {
                let id = params.id;
                this.worktime.delete(id).then(this.loadTable);
            }
            else
            {
                console.log('Error: delete_item_undefined');
            }
        },
        loadTable: async function () {
            let response = await this.worktime.loadTable(this.page, this.limit, this.search);
            this.tbody = response.tbody;
            this.count = response.pages;
            if(this.page > 1 && this.tbody.length === 0)
            {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        }
    },
    mounted() {
        this.loadTable();
    }
}
</script>

<style scoped>

</style>
